/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
export const findItemTreeByPathname = (items, pathname) => {
  if (typeof items === 'undefined') {
    return false;
  }

  let found = items.find((item) => item.path === pathname);

  if (found) {
    return found;
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < items.length; i++) {
    found = findItemTreeByPathname(items[i].items, pathname);

    if (found) {
      return found;
    }
  }

  return false;
};

export const modifyItemTreeByPathname = (currentMenu, pathname) => {
  if (!currentMenu || !pathname) {
    return;
  }

  const checkMenuItem = (menuItem) => {
    if (menuItem.path === pathname) {
      return true;
    }

    if (menuItem.items) {
      for (const item of menuItem.items) {
        const isCheckedItem = checkMenuItem(item);
        if (isCheckedItem) {
          return true;
        }
      }
    }

    menuItem.checked = true;

    return false;
  };

  for (const item of currentMenu) {
    if (checkMenuItem(item)) {
      return;
    }
  }
};
